export enum TournamentStatus {
  active = 'active',
  upcoming = 'upcoming',
  finished = 'finished',
}

export interface Tournament {
  id: number;
  name: string;
  description: string;
  prizePool: string;
  participants: number;
  timeLeft: string;
  status: TournamentStatus;
  sport: string;
  sport_type?: string;
  isRegistered: boolean;
  requiresOptIn: boolean;
  backgroundImage: string;
  startDate: string;
  endDate: string;
  isLoggedIn: boolean;
}

export interface TournamentGrid extends Tournament {
  maxParticipants: number;
  entryFee: string;
}

export interface TournamentHero extends Tournament {
  subtitle: string;
  featured: boolean;
}

export interface TournamentHeader {
  id: number;
  name: string;
  description: string;
  startDate: string;
  endDate: string;
  status: TournamentStatus;
  totalParticipants: number;
  prizePool: string;
  backgroundImage: string;
  isRegistered: boolean;
}

export interface TournamentCardProps {
  tournament: Tournament;
}

export interface TournamentGridProps {
  tournaments: TournamentGrid[];
}

export interface TournamentHeroSingleProps {
  tournament: TournamentHero;
}

export interface TournamentHeroCarouselProps {
  tournament: TournamentHero[];
}

export interface TournamentHeaderProps {
  tournament: TournamentHeader;
}
